import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TX5BankButton } from './models';
import './styles/styles.css';

export const X5BankButton: FC<TX5BankButton> = ({
    Button,
    children,
    disabled,
    loading,
    styles,
    view,
    ...props
}) => {
    return (
        <Button
            disabled={disabled}
            innerClassName={cn({
                [styles.greenColor]: view === 'primary',
                [styles.greenColorDisabled]: disabled,
                [styles.greenColorLoading]: loading,
                [styles.external]: true,
            })}
            loading={loading}
            view={view}
            {...props}
        >
            {children}
        </Button>
    );
};
